import { AufnahmePunktDocument } from "src/app/data-model";
import { EvalFunc } from "../evaluation.service";

export const maechtigkeitEval: EvalFunc = (bp: any, i?: number, key?: string, tiefeOverride?: number, atEnd?: boolean) => {
    const b = bp as AufnahmePunktDocument;
    if (i === undefined) return;
    switch (key) {
			case 'SMächtigkeit': {
				const t = tiefeOverride ?? b.Substratfolge[i].tiefe;
				return i == 0 && !atEnd
						? t
						: t - b.Substratfolge[atEnd ? i : i - 1].tiefe;
			}
      case 'HMächtigkeit': {
				const t = tiefeOverride ?? b.Horizontfolge[i].tiefe;
				return i == 0 && !atEnd
						? t
						: t - b.Horizontfolge[atEnd ? i : i - 1].tiefe;
			}
      default: return;
    }
};
